import { Map } from 'immutable';

import * as types from './types';

const initialState = Map({
  loading: true,
});

const embeddedContainerReducer = (state = initialState, { type }) => {
  switch (type) {
    case types.INITIALIZE:
      return state.set('loading', false);
    default:
      return state;
  }
};


export default embeddedContainerReducer;
